import { Stack } from '@mui/material';
import React from 'react';

type Props = {
  children: JSX.Element | JSX.Element[];
};

export const CreateDialogLayout: React.FC<Props> = ({ children }) => {
  return (
    <Stack direction="column" spacing={2}>
      {children}
    </Stack>
  );
};
